module.exports = __webpack_public_path__ + "img/realsmart.a8074e84.png";